// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-k_gB","advertDetailContacts__header":"c-k_gC"};